import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

const NetworkImage = styled.img<React.CSSProperties>`
  position: absolute;
  width: ${200 * Screen.widthRatio}px;
  top: 25%;
  left: ${860 * Screen.widthRatio}px;
`;

export default withImage(NetworkImage, true);
